import { makeAutoObservable, runInAction } from "mobx";
import { IRestockRequest, IRmaRestockActionStore } from "../../rma-types";
import RmaPageStore from "../rma-page-store";

class RmaRestockActionStore implements IRmaRestockActionStore {
    private _model: Partial<IRestockRequest> = {};
    private _isProcessing: boolean = false;

    constructor(private _rma: RmaPageStore, private _actionCallback: (data: IRestockRequest) => void) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get restockingLocationId(): string | undefined {
        return this._model.restocking_location_id;
    }
    public get selectedProductCaseIds(): number[] {
        return this._model.selected_product_case_ids ?? [];
    }
    public get isProcessing(): boolean {
        return this._isProcessing;
    }

    public setRestockingLocationId(v: string) {
        this._model.restocking_location_id = v;
    }

    public setSelectedProductCaseIds(v: number[]) {
        this._model.selected_product_case_ids = v;
    }

    private requestModel(): IRestockRequest {
        return {
            selected_product_case_ids: this.selectedProductCaseIds,
            restocking_location_id: this.restockingLocationId,
        };
    }

    public async submitAction(closeCb?: () => void) {
        try {
            this._isProcessing = true;
            await this._actionCallback(this.requestModel());
            runInAction(() => {
                this._isProcessing = false;
                if (closeCb) {
                    closeCb();
                }
            });
        } catch (e) {
            runInAction(() => {
                this._isProcessing = false;
            });
        }
    }
}

export default RmaRestockActionStore;
